import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import axios from "axios";
import { Lock } from "lucide-react";
import { API } from "@/shop/api";

const AdminLogin = () => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (localStorage.getItem("zentra-admin-token")) return <Navigate to="/admin/orders" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem("zentra-admin-token", data.token);
      navigate("/admin/orders");
    } catch {
      setError("Incorrect password. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A] px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#121212] p-8">
        <img src="/assets/zentra-logo-white.png" alt="ZENTRA" className="mx-auto h-10 w-auto" />
        <h1 className="mt-6 text-center font-display text-2xl uppercase tracking-wide text-white">Admin</h1>
        <div className="mt-6">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Admin password"
            data-testid="admin-password-input"
            className="w-full rounded-xl border border-white/15 bg-[#0A0A0A] px-4 py-3.5 text-sm text-white placeholder:text-white/30 outline-none focus:border-[#7ED321]"
          />
        </div>
        {error && <p className="mt-3 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-button"
          className="mt-5 flex w-full items-center justify-center gap-2 rounded-full bg-[#7ED321] py-3.5 text-sm font-bold uppercase tracking-[0.12em] text-[#0A0A0A] transition-colors hover:bg-[#8FE331] disabled:opacity-50"
        >
          <Lock className="h-4 w-4" />
          {loading ? "Signing in…" : "Sign In"}
        </button>
        <a href="/" className="mt-5 block text-center text-xs text-white/40 hover:text-[#7ED321]">Back to site</a>
      </form>
    </div>
  );
};

export default AdminLogin;
